import React from 'react';
import { Button } from '@/components/ui/button';
import { APP_BASE_URL } from '@/config/urls';

const PaymentDomainLanding: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-white to-gray-50 p-4 text-center">
      <div className="w-full max-w-md space-y-8">
        <div>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900">BillPa.id</h1>
          <p className="mt-3 text-xl text-gray-600">
            This is a payment-only domain for KeepMore
          </p>
        </div>
        
        <div className="mt-6">
          <p className="text-gray-600 mb-8">
            Save money on every payment by reducing transaction fees.
            Use KeepMore to start saving on payment processing fees today.
          </p>
          
          <Button 
            className="w-full py-6 text-lg bg-blue-600 hover:bg-blue-700"
            onClick={() => window.location.href = APP_BASE_URL}
          >
            Visit KeepMore.co to Get Started
          </Button>
          
          <p className="mt-4 text-sm text-gray-500">
            This domain is reserved for processing payments only.
            To create payment pages, please visit the main website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentDomainLanding;
